//引入VUE
import Vue from 'vue';

//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入APP组件，所有组件的父组件
import App from './App.vue'
//引入路由
import VueRouter from "vue-router";
import router from "@/router";
//引入请求
import axios from "axios";
import qs from "qs";
//引入百度地图
import BaiduMap from 'vue-baidu-map';
//引入微信sdk
import wx from 'weixin-js-sdk'
//引入vant UI
import Vant from "vant"
import "vant/lib/index.css"
import { ImagePreview } from 'vant';
// 全局注册
Vue.use(ImagePreview);
import { List } from 'vant';

Vue.use(List);

import VueMeta from 'vue-meta';
import VueI18n from "vue-i18n";

Vue.prototype.$qs = qs;
//挂载微信
Vue.prototype.$wx = wx
//引用多语言
Vue.use(VueI18n)




//关闭VUE生产提示
Vue.config.productionTip = false
//应用路由插件
Vue.use(VueRouter);
Vue.use(ElementUI);

Vue.use(VueMeta);

Vue.use( BaiduMap, { ak : 'R3wbVjUegl3eLFgnuZOCSCGW4gdaQf6q' } )

Vue.use(Vant)

//配置请求原型
Vue.prototype.axios = axios;
axios.defaults.baseURL = '/api';

//创建VUE实例对象--VM
new Vue({
  render: h => h(App),
  router:router

}).$mount('#app')
